import React, { useState, useEffect } from "react";
import axios from "axios";
import { Typography, Row, Col, Button, Input, Flex } from "antd";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import JudgeTable from "../components/JudgeTable";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { firebaseAPI } from "../firebaseConfig";
import axiosInstance from "../utils/axiosInstance";

const JudgePage = () => {
  // State to store judges data
  const [judges, setJudges] = useState([]);
  // State to store the filter options
  const [filter, setFilter] = useState("");
  const location = useLocation();
  const [program, setProgram] = useState(
    decodeURI(location.pathname.split("/")[1])
  );

  // Fetch judges data from the server
  useEffect(() => {
    fetchJudges();
  }, []);

  const fetchAndDownloadJudgeCSV = async () => {
    // try {
    //     let token = Cookies.get('token') || '';
    //     const response = await axiosInstance.get(`http://localhost:5000/participants`, {
    //         headers: {
    //             Authorization: `Bearer ${token}`
    //         }
    //     });
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/users/${program}/judges`,
        {
          headers: {
            // A temporary way to manually use token until implement the sign-in feature
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const participants = response.data; // Assuming response.data is the array of participants}

      // Step 2: Convert data to CSV format
      const csvContent = participants
        .map((participant) => Object.values(participant).join(","))
        .join("\n");
      const csvBlob = new Blob([csvContent], { type: "text/csv" });

      // Step 3: Trigger file download
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(csvBlob);
      downloadLink.download = "judge.csv";
      downloadLink.click();
    } catch (error) {
      console.error("Error fetching or downloading participants:", error);
    }
  };

  const exportJudgesToCSV = (judges) => {
    const headers = [
      "Name",
      "Email",
      "Remaining Evaluations",
      "Total Evaluations",
    ];
    const rows = judges.map((j) => [
      j.name || "",
      j.email || "",
      j.remainingAssignments ?? "",
      j.totalAssigned ?? "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "judges_export.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchJudges = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/users/${program}/judges`,
        {
          headers: {
            // A temporary way to manually use token until implement the sign-in feature
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setJudges(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Function to handle filter change
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  // Filtered judges based on the selected options
  const filteredJudges = judges.filter((judge) => {
    if (
      filter &&
      !(
        judge.name.toLowerCase().includes(filter.toLowerCase()) ||
        judge.email.toLowerCase().includes(filter.toLowerCase())
      )
    ) {
      return false;
    }
    return true;
  });

  return (
    <Container maxW="container.lg" mt={6} bg="#F7F7F7" p={6} borderRadius="md">
      {/* Header: Title and Export Button */}
      <Flex justify="space-between" align="center" mb={8}>
        <Heading as="h1" size="2xl">
          Judges Page
        </Heading>
        <Button
          colorScheme="blue"
          onClick={() => exportJudgesToCSV(filteredJudges)}
          size="lg"
          px={6}
          py={4}
          fontSize="lg"
        >
          Export CSV
        </Button>
      </Flex>

      {/* Search Input and Add Judge Button */}
      <Flex
        mb={8}
        align="center"
        justify={{ base: "center", md: "space-between" }}
        flexDirection={{ base: "column", md: "row" }}
        gap={4}
      >
        <Box flex="1" maxW={{ base: "100%", md: "400px" }}>
          <Text fontSize="md" mb={2}>
            Search by Name or Email
          </Text>
          <Input
            placeholder="Enter name or email"
            value={filter}
            onChange={handleFilterChange}
            size="lg"
            bg="white"
            borderColor="gray.300"
            fontSize="md"
            _placeholder={{ fontSize: "md", color: "gray.500", px: 2 }}
          />
        </Box>

        <Link to={`/${program}/addjudge`} style={{ width: "auto" }}>
          <Button
            colorScheme="teal"
            size="lg"
            borderRadius="md"
            fontSize="lg"
            px={8}
            py={4}
          >
            Add Judge
          </Button>
        </Link>
      </Flex>

      {/* Table Container */}
      <Box bg="white" p={6} borderRadius="md" boxShadow="md">
        <JudgeTable judges={filteredJudges} />
      </Box>
    </Container>
  );
};

export default JudgePage;
